import { render, staticRenderFns } from "./ZigZag.vue?vue&type=template&id=e345968c&"
import script from "./ZigZag.vue?vue&type=script&lang=js&"
export * from "./ZigZag.vue?vue&type=script&lang=js&"
import style0 from "./ZigZag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports